export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 overflow-hidden border-t border-white/10 bg-black"
    >
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <span className="font-display select-none text-[20vw] font-semibold tracking-tighter text-white/[0.03]">
          ARVEX
        </span>
      </div>

      <div className="relative mx-auto grid max-w-[1400px] gap-10 px-6 py-16 md:grid-cols-4 md:px-10 md:py-24">
        <div className="md:col-span-2">
          <div className="font-display text-2xl font-semibold tracking-tighter">
            ARVEX
          </div>
          <p className="mt-3 max-w-xs text-sm text-white/50">
            Capture every run. Analyze every turn. Improve every session.
          </p>
        </div>

        <div>
          <div className="label-mono mb-4">System</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a href="#device" className="hover:text-white">Capture Unit</a></li>
            <li><a href="#run" className="hover:text-white">Timing Gates</a></li>
            <li><a href="#vision" className="hover:text-white">Analysis</a></li>
          </ul>
        </div>

        <div>
          <div className="label-mono mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><a href="#waitlist" className="hover:text-white">Waitlist</a></li>
            <li><a href="#contact" className="hover:text-white">Clubs &amp; Teams</a></li>
            <li><a href="mailto:hello@arvex.cc" className="hover:text-white">hello@arvex.cc</a></li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-3 px-6 py-6 md:flex-row md:items-center md:px-10">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
            © {new Date().getFullYear()} Arvex Systems · arvex.cc
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
            Built for the slope · Engineered in the Alps
          </div>
        </div>
      </div>
    </footer>
  );
}
